import componentRegistry from '../QuoteComponents';
import Grid from '@mui/material/Grid';
// import Collapse from '@mui/material/Collapse';
import { HelpIcon } from '../HelpIcon';

// types
import type { $TSFixMe, GenericObject } from '@calefy-inc/utilityTypes';
import { QuoteWizardQuestionInstance } from '../../QuoteWizard/classes';

type RenderedQuestionInstanceProps = {
  questionInstance: null | QuoteWizardQuestionInstance;
  classes?: GenericObject;
  blockAddSubquestions?: boolean;
  // keepState?: boolean;
  // keepStateIfRelevant?: boolean;
  keepStateIfRelevant?: boolean;
  [key: string]: $TSFixMe;
};
export default function RenderedQuestionInstance({
  questionInstance,
  blockAddSubquestions,
  classes = {},
  keepStateIfRelevant = false,
}: RenderedQuestionInstanceProps) {
  if (!questionInstance) {
    return null;
  }

  const QuoteComponent = componentRegistry.getQuoteComponent(
    questionInstance.component,
  );

  const HelpText = questionInstance.helpText;

  if (
    QuoteComponent &&
    HelpText &&
    (!questionInstance.subQuestions ||
      questionInstance.subQuestions.length === 0)
  ) {
    return (
      <Grid container alignItems='center'>
        <Grid item xs={11}>
          <div
            id={questionInstance.generateFieldName()}
          >
            <QuoteComponent
              classes={classes}
              questionInstance={questionInstance}
              blockAddSubquestions={blockAddSubquestions}
              keepStateIfRelevant={keepStateIfRelevant}
            />
          </div>
        </Grid>
        <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center' }}>
          <HelpIcon title={HelpText} />
        </Grid>
      </Grid>
    );
  } else if (QuoteComponent) {
    return (
      <div id={questionInstance.generateFieldName()}>
        <QuoteComponent
          classes={classes}
          questionInstance={questionInstance}
          blockAddSubquestions={blockAddSubquestions}
          keepStateIfRelevant={keepStateIfRelevant}
        />
      </div>
    );
  } else {
    console.error(
      `In RenderedQuestionInstance: Component not found for ${JSON.stringify(
        questionInstance,
        null,
        4,
      )}`,
    );
    return null;
  }
}
